import store from '@/store';
import i18n from '@/language/i18n'

const isNoPermission = (error) => error.status === 403;

const showNoPermissionError = () => {
    let errors = [{
        fieldName: i18n.t('Common.general'),
        message: i18n.t('Components.sentences.noPermission'),
    }];
    store.dispatch('errorNotificationStore/setErrors', errors);
    store.dispatch('errorNotificationStore/showErrorNotification');
}

export { isNoPermission, showNoPermissionError }